import React, { useMemo, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

interface IYearPickerProps {
  initialValue?: number;
  onChange?: (value: number) => void;
}

const YearPicker: React.FC<IYearPickerProps> = (
  { initialValue, onChange }): React.JSX.Element => {
  const currentYear = new Date().getFullYear();
  
  // Dynamically generate the years array
  const years = useMemo(() => {
    const startYear = 2020;
    const endYear = currentYear + 10;
    const yearsArray = [];

    for (let year = startYear; year <= endYear; year++) {
      yearsArray.push({
        name: year.toString(),
        index: year,
      });
    }
    return yearsArray;
  }, [currentYear]);

  const [value, setValue] = useState(initialValue || currentYear);

  const handleChange = (val: number) => {
    setValue(val);
    if (onChange) {
      onChange(val);
    }
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel id="year-label">Start Year</InputLabel>
      <Select value={value} labelId="year-label" label="Start Year"
        onChange={(event) => handleChange(event.target.value as number)}
      >
        {years.map((yearObj) => (
          <MenuItem key={yearObj.index} value={yearObj.index}>
            {yearObj.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default YearPicker;
